import Parse from "parse";

import type { _User } from "./_User";

type OD3_Tenant = Parse.Object;

export interface Ticket_QR_CodeAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  code: string;
  name?: string;
  tenant?: OD3_Tenant;
  user?: _User;
}

export class Ticket_QR_Code extends Parse.Object<Ticket_QR_CodeAttributes> {
  static className: string = "OD3_Maintenance_Ticket_QR_Code";

  constructor(data?: Partial<Ticket_QR_CodeAttributes>) {
    super("OD3_Maintenance_Ticket_QR_Code", data as Ticket_QR_CodeAttributes);
  }

  get code(): string {
    return super.get("code");
  }
  set code(value: string) {
    super.set("code", value);
  }
  get name(): string | undefined {
    return super.get("name");
  }
  set name(value: string | undefined) {
    super.set("name", value);
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get user(): _User | undefined {
    return super.get("user");
  }
  set user(value: _User | undefined) {
    super.set("user", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Ticket_QR_Code", Ticket_QR_Code);
